/**
 * Destinos que uma notificação push pode abrir dentro do app.
 *
 * Isto NÃO é higiene de segurança apenas: o `App.tsx` não tem rota catch-all
 * (`*`), então navegar para um path desconhecido renderiza tela BRANCA. Um
 * payload torto — versão antiga do app recebendo rota nova, campo digitado
 * errado no admin, mensagem de terceiro — quebraria o app em vez de ser
 * ignorado. Aqui, o que não está na lista simplesmente não navega.
 *
 * A lista espelha `ROUTE_CHOICES` de `bow/notifications/broadcast.py`. Ao
 * adicionar destino novo, os dois lados mudam juntos — e o app precisa do OTA
 * antes de o admin passar a oferecer a rota.
 *
 * Exceção: `/charging/<id>` vem de push TRANSACIONAL (aviso de que a recarga
 * vai parar por saldo, `notify_recarga_vai_parar`), não do combo do admin —
 * é rota de uma sessão só, não faz sentido em broadcast.
 */

const UUID = '[0-9a-fA-F-]{36}';

const ALLOWED: RegExp[] = [
  /^\/$/,
  /^\/wallet$/,
  /^\/wallet\/recharge$/,
  /^\/history$/,
  /^\/alianca$/,
  /^\/indique$/,
  /^\/profile$/,
  new RegExp(`^/stations/${UUID}$`),
  new RegExp(`^/amenities/${UUID}/vacuum$`),
  new RegExp(`^/charging/${UUID}$`)
];

/**
 * Devolve o path se for um destino conhecido, senão `null`.
 *
 * Recusa qualquer coisa que não seja path interno: `//host` (protocol-relative,
 * viraria navegação externa), URL absoluta e valor que não seja string.
 */
export function safePushRoute(raw: unknown): string | null {
  if (typeof raw !== 'string') return null;
  const path = raw.trim();
  if (!path.startsWith('/')) return null;
  if (path.startsWith('//')) return null;
  return ALLOWED.some((re) => re.test(path)) ? path : null;
}
